import React from 'react';
import { useSite } from '../../context/SiteContext';
import { resolveMediaUrl } from '../admin/MediaUpload';

export default function PaymentsWeAccept() {
  const { data } = useSite();
  const pa = data.paymentsWeAccept || {};
  const visible = (data.sectionVisibility || {}).paymentsWeAccept !== false;
  if (!visible || pa.enabled === false) return null;
  const logos = (pa.logos || []).filter((l) => l && (l.image || l.label));
  if (!logos.length) return null;

  // Duplicate list to guarantee seamless infinite loop
  const loop = [...logos, ...logos, ...logos, ...logos];

  return (
    <div id="payments-we-accept" className="rounded-2xl bg-zinc-950/70 border border-zinc-800/80 shadow-2xl p-4 md:p-6 my-4 overflow-hidden" data-testid="payments-we-accept-section">
      <div className="text-center mb-5">
        <h2 className="text-white font-extrabold text-base md:text-lg tracking-tight uppercase">
          {pa.title || 'PAYMENT WE ACCEPT'}
        </h2>
        <p className="text-zinc-400 text-xs mt-0.5">
          Fast & secure instant deposit and withdrawal channels
        </p>
      </div>

      {/* Inline Left-to-Right Continuous Auto-Scrolling Track */}
      <div className="relative overflow-hidden py-3 [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]">
        <div className="flex items-center marquee-track-reverse gap-8 md:gap-12">
          {loop.map((l, i) => (
            <div
              key={l.id ? `${l.id}-${i}` : i}
              className="shrink-0 h-11 md:h-13 px-4 py-1.5 rounded-xl bg-zinc-900/80 border border-zinc-800/80 flex items-center justify-center shadow-sm hover:border-[color:var(--gold)]/40 hover:bg-zinc-850 transition-all duration-300"
              data-testid={`payment-logo-${l.id || i}`}
            >
              {l.image ? (
                <img
                  src={resolveMediaUrl(l.image)}
                  alt={l.label || `pay-${i}`}
                  className="max-h-8 md:max-h-9 max-w-[140px] object-contain filter drop-shadow hover:scale-105 transition-transform"
                />
              ) : (
                <span className="text-zinc-200 text-xs md:text-sm font-bold whitespace-nowrap tracking-wide">
                  {l.label}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
